import deepmerge from 'deepmerge';

export const defaultIconography = {
  small: {
    width: 15,
    height: 15,
    fontsize: 13
  },
  medium: {
    width: 25,
    height: 25,
    fontsize: 21
  }
};

const createPalette = ({
  type,
  grey60,
  grey300,
  grey900,
  white
}: any) => {
  if (type == 'light') {
    return {
      color1: grey300,
      color2: white,
      color3: white
    }
  }
  return {
    color1: grey60,
    color2: grey900,
    color3: white
  };
};

const createIcon = ({
  color1,
  color2,
  color3
}: any) => ({
  icon: {
    color: color1
  },
  iconInverted: {
    color: color2
  },
  iconSelected: {
    color: color3
  }
});

export const createIconography = (palette: any, iconography = {}) => {
  const otherOptions
      = typeof iconography == 'function' ? iconography(palette) : iconography;
  const iconPalette = createPalette(palette);
  const options = {
    ...createIcon(iconPalette),
    ...defaultIconography
  };
  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return mergedOptions;
};
